import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectCurrent } from '@gandi/redux-sharing';
import { mapTags, useTranslator } from '@gandi/translate';
import { Text } from '@gandi/ui';
import { selectCartIsActive } from '../../../../modules/selectors';
import { selectCartWidgetShowPrices } from '../../../../modules/widget/selectors';
import CartContentContext from '../../CartContentContext';
import { selectCartOwnerOrganization } from '../../modules/selectors';
import { jsx as _jsx } from "react/jsx-runtime";
export default function PricesFor() {
  const {
    __,
    formatCurrency
  } = useTranslator();
  const prices = useSelector(selectCartWidgetShowPrices);
  const active = useSelector(selectCartIsActive);
  const organization = useSelector(selectCartOwnerOrganization);
  const current = useSelector(selectCurrent);
  const {
    preferences
  } = React.useContext(CartContentContext);
  if (organization) {
    return mapTags(__('Prices for [[organization:]]'), () => ({
      organization: /*#__PURE__*/_jsx(Text, {
        weight: "semibold",
        children: organization.name
      })
    }));
  }
  if (current) {
    return mapTags(__('Prices for [[organization:]]'), () => ({
      organization: /*#__PURE__*/_jsx(Text, {
        weight: "semibold",
        children: current.name
      })
    }));
  }
  if (prices || !active) {
    if (preferences) {
      const {
        country,
        currency,
        taxesIncluded
      } = preferences;
      const taxesLabel = taxesIncluded ? __('taxes included') : __('taxes excluded');
      const currencyLabel = __('%(currencySymbol)s (%(currency)s)', {
        currencySymbol: formatCurrency(currency),
        currency
      });
      return country ? mapTags(__('Prices for [[country:]], [[taxes:]] in [[currency:]]'), () => ({
        country: /*#__PURE__*/_jsx(Text, {
          weight: "semibold",
          children: country
        }),
        taxes: taxesLabel,
        currency: currencyLabel
      })) : mapTags(__('Prices are in [[currency:]], [[taxes:]]'), () => ({
        taxes: taxesLabel,
        currency: currencyLabel
      }));
    }
  }
  return active && !prices ? __('Prices updated at the next step') : null;
}